'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require('react');
var React__default = _interopDefault(React);
var functions = require('@keytrade/functions');
var styled = _interopDefault(require('styled-components'));
var PropTypes = _interopDefault(require('prop-types'));
var MaskedInput = require('react-text-mask');
var MaskedInput__default = _interopDefault(MaskedInput);
var componentsButton = require('@keytrade/components-button');
var componentsVisuallyhidden = require('@keytrade/components-visuallyhidden');
var componentsLabel = require('@keytrade/components-label');
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
var colors = functions.config.colors.list;
var IcnCheckCircle = function IcnCheckCircle(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.5rem",
    height: "2.5rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: colors.GreenSeafoam,
    fillRule: "evenodd",
    d: "M12 3c4.995 0 9 4.008 9 9s-4.008 9-9 9-9-4.008-9-9 4.005-9 9-9zm5.481 14.481c1.479-1.478 2.28-3.388 2.28-5.481s-.801-4.003-2.28-5.481C16.003 5.04 14.093 4.239 12 4.239s-4.003.801-5.481 2.28C5.04 7.997 4.239 9.907 4.239 12s.801 4.003 2.28 5.481c1.478 1.479 3.388 2.28 5.481 2.28s4.003-.801 5.481-2.28zm-7.122-2.835l-2.33-2.349a.682.682 0 0 1 .138-.97.721.721 0 0 1 .995.134l1.707 1.544 3.52-3.23a.721.721 0 0 1 .979-.221c.332.202.435.63.227.955l-4.067 4.085a.711.711 0 0 1-.57.326l-.033.001a.714.714 0 0 1-.566-.275z"
  }));
};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var lib = createCommonjsModule(function (module) {
  /**
   * RegexParser
   * Parses a string input.
   *
   * @name RegexParser
   * @function
   * @param {String} input The string input that should be parsed as regular
   * expression.
   * @return {RegExp} The parsed regular expression.
   */
  var RegexParser = module.exports = function (input) {
    // Validate input
    if (typeof input !== "string") {
      throw new Error("Invalid input. Input must be a string");
    }

    // Parse input
    var m = input.match(/(\/?)(.+)\1([a-z]*)/i);

    // Invalid flags
    if (m[3] && !/^(?!.*?(.).*?\1)[gmixXsuUAJ]+$/.test(m[3])) {
      return RegExp(input);
    }

    // Create the regular expression
    return new RegExp(m[2], m[3]);
  };
});
var colors$1 = functions.config.colors.list;
var IcnCross = function IcnCross() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: colors$1.BlueCloudy,
    d: "M13.9 12.25l5.42-5.42a.5.5 0 0 0 0-.71l-.94-.94a.5.5 0 0 0-.71 0l-5.42 5.42-5.42-5.42a.5.5 0 0 0-.71 0l-.94.94a.5.5 0 0 0 0 .71l5.42 5.42-5.42 5.42a.5.5 0 0 0 0 .71l.94.94a.5.5 0 0 0 .71 0l5.42-5.42 5.42 5.42a.5.5 0 0 0 .71 0l.94-.94a.5.5 0 0 0 0-.71l-5.42-5.42z"
  }));
};
var colors$2 = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var FILE_TYPE = 'file';
var InputOnlyWrapper = styled.div.withConfig({
  displayName: "InputTextOnlystyled__InputOnlyWrapper",
  componentId: "sc-1etwwqq-0"
})(["margin:", ";position:relative;", " max-width:100%;flex:1 1 auto;display:flex;align-items:center;justify-content:center;border-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";", " border-style:solid;border-width:1px;background-color:", ";", " ", " ", " height:", ";cursor:pointer;input{height:", ";width:100%;padding:0 1rem;font-family:", ";font-size:", ";border:none;background-color:transparent;white-space:nowrap;color:", ";text-overflow:ellipsis;&:disabled{cursor:not-allowed;}&::placeholder{color:", ";}&::-ms-clear{display:none;}&:invalid{box-shadow:none;}", "}", "}"], function (props) {
  return props.margin;
}, function (props) {
  return props.append && 'left: -.1rem;';
}, function (props) {
  return props.error ? colors$2.Tomato : props.theme.dark ? colors$2.GreyBlue : colors$2.GreyLight;
}, function (props) {
  return props.append ? '0' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : '.3rem';
}, function (props) {
  return props.append ? '0' : '.3rem';
}, function (props) {
  return props.isFocused && 'z-index: 1;';
}, function (props) {
  return props.disabled ? colors$2.GreyWhite : props.theme.dark ? colors$2.BlueMoon : colors$2.White;
}, function (props) {
  return props.disabled ? 'cursor: not-allowed;' : null;
}, function (props) {
  return props.isFocused && !props.disabled ? "box-shadow: 0 0 .4rem 0 ".concat(colors$2.BlueCloudyTransparent, ";") : null;
}, function (props) {
  return !props.disabled && "\n    &:hover {\n      box-shadow: 0 0 .4rem 0 ".concat(colors$2.BlueCloudyTransparent, ";\n    }\n    & span {color: ").concat(colors$2.BlueSky, ";}\n    &:hover span {\n          color: ").concat(colors$2.BlueHeaven, ";\n          transition: all 0.2s ease;\n        }\n  ");
}, function (_ref) {
  var theme = _ref.theme;
  return theme.type === 'secure' ? '3.4rem' : '4.4rem';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.type === 'secure' ? '3.4rem' : '4.4rem';
}, function (_ref3) {
  var theme = _ref3.theme;
  return getFont(theme, theme.type === 'secure' ? 'regular' : 'semiBold');
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.type === 'secure' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.disabled ? colors$2.GreyWarm : props.theme.dark ? colors$2.White : colors$2.BlueDark;
}, function (props) {
  return props.theme.dark ? colors$2.BlueCloudy : colors$2.GreyWarm;
}, function (_ref5) {
  var type = _ref5.type;
  return type === FILE_TYPE && "\n        opacity:0;\n        height:100%;\n        width:100%;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        z-index: 10;\n        cursor: pointer;\n    ";
}, function (props) {
  return props.theme.dark ? "  & {\n      &:focus, &:focus-visible, .focus-visible {\n        box-shadow: rgba(0 179 219 / 26%) 0 0 0.4rem 0;\n        border:1px solid #64dfff;\n        border-radius: 4px;\n        outline: none;\n      }\n    }" : "  & {\n      &:focus, &:focus-visible, .focus-visible {\n        box-shadow: rgba(167 189 204 / 50%) 0 0 0.4rem 0;\n        border:1px solid #007f9e;\n        border-radius: 4px;\n        outline: none;\n      }\n    }";
});
var InputFilePlaceHolder = styled.div.withConfig({
  displayName: "InputTextOnlystyled__InputFilePlaceHolder",
  componentId: "sc-1etwwqq-1"
})(["height:", ";line-height:", ";width:100%;padding:0 1rem;font-size:1.4rem;border:none;background-color:transparent;white-space:nowrap;text-overflow:ellipsis;text-align:center;overflow:hidden;color:", ";max-width:100%;overflow:hidden;text-overflow:ellipsis;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.type === 'secure' ? '3.4rem' : '4.4rem';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.type === 'secure' ? '3.4rem' : '4.4rem';
}, function (props) {
  return props.disabled ? colors$2.GreyWarm : props.theme.dark ? colors$2.White : colors$2.BlueDark;
});
var InputFileNameDisplay = styled.div.withConfig({
  displayName: "InputTextOnlystyled__InputFileNameDisplay",
  componentId: "sc-1etwwqq-2"
})(["height:", ";line-height:", ";width:100%;padding:0 1rem;font-size:1.4rem;border:none;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.type === 'secure' ? '3.4rem' : '4.4rem';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.type === 'secure' ? '3.4rem' : '4.4rem';
}, function (props) {
  return props.disabled ? colors$2.GreyWarm : props.theme.dark ? colors$2.White : colors$2.BlueDark;
});
var Suffix = styled.div.withConfig({
  displayName: "InputTextOnlystyled__Suffix",
  componentId: "sc-1etwwqq-3"
})(["padding-right:1rem;font-size:1.2rem;line-height:1.6rem;color:", ";font-family:", ";"], function (props) {
  return props.theme.dark ? colors$2.White : colors$2.BlueDark;
}, function (_ref10) {
  var theme = _ref10.theme;
  return getFont(theme, 'bold');
});
var CloseWrapper = styled.div.withConfig({
  displayName: "InputTextOnlystyled__CloseWrapper",
  componentId: "sc-1etwwqq-4"
})(["z-index:10;padding:0.2rem;cursor:pointer;appearance:none;border:0;background:", ";border-radius:0.3rem;font-size:0;svg{max-height:100%;}"], colors$2.Transparent);
var MONEY_TYPE = 'money';
var FILE_TYPE$1 = 'file';
var MIN_DECIMALS = 2;
var ALLOWED_INPUTMODES = ['none', 'text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url'];
var availableLanguages = ['en', 'nl', 'fr', 'de'];
var InputTextLabel = {
  en: {
    defaultText: ' or drag it here',
    linkText: 'Choose a file'
  },
  nl: {
    defaultText: ' of sleep hierheen',
    linkText: 'Kies een bestand'
  },
  fr: {
    defaultText: ' ou déposez le ici',
    linkText: 'Choisissez un fichier'
  },
  de: {
    defaultText: ' oder legen Sie sie hier ab',
    linkText: 'Wählen Sie eine Datei aus'
  }
};
var isValidMask = function isValidMask(mask) {
  return mask && (mask.length || typeof mask === 'function');
};
var InputTextOnly = /*#__PURE__*/function (_Component) {
  /**
   * 1. Saves the amount of decimals of the value passed on
   *    as prop into the state.
   */
  function InputTextOnly(props) {
    var _this;
    _classCallCheck(this, InputTextOnly);
    _this = _callSuper(this, InputTextOnly, [props]);
    /**
     * @function componentDidUpdate
     * @param {Object} prevProps
     *
     * 1. Updates the value printed in the input.
     */
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      if (prevProps.value !== _this.props.value) {
        var newValue = _this.prepareValue(_this.props.value);
        if (prevProps.value !== newValue) {
          _this.setState({
            value: _this.getValueFormatted(newValue, true) /* [1] */
          });
        }
      }
    });
    /**
     * @function getAmountOfDecimals
     * @param {String|Number} number - the number to format
     * @param {Boolean} allDecimals - should all decimals be preserved or not
     * @returns {Integer}
     *
     * 1. Never less than the minimum amount of decimals
     */
    _defineProperty(_this, "getAmountOfDecimals", function (number, allDecimals) {
      var valueStr = typeof number === 'number' ? number.toString() : number;
      var _valueStr$split = valueStr.split(/[.,]/),
        _valueStr$split2 = _slicedToArray(_valueStr$split, 2),
        _valueStr$split2$ = _valueStr$split2[1],
        fraction = _valueStr$split2$ === void 0 ? '' : _valueStr$split2$;
      return fraction.length > MIN_DECIMALS && allDecimals ? fraction.length : MIN_DECIMALS; /* [1] */
    });
    /**
     * @function getValueFormatted
     * @param {Number|String} value - the value to format
     * @param {Boolean} stillTyping - wether the formatting is done
     *   during or after the input.
     * @returns {String}
     *
     * 1. Trailing commas and zeros are preserved during input.
     */
    _defineProperty(_this, "getValueFormatted", function (value) {
      var stillTyping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
        showAllDecimals = _this$props.showAllDecimals,
        inputType = _this$props.type,
        guide = _this$props.guide;
      var valueStr = typeof value === 'number' ? value.toString() : value;
      if (valueStr && inputType === MONEY_TYPE) {
        return functions.format.number(valueStr, _this.amountOfDecimals, {
          forceFloat: false,
          limitDecimals: !showAllDecimals,
          allowPrecision: stillTyping /* [1] */
        });
      }
      var mask = _this.props.mask;
      return isValidMask(mask) && valueStr !== '' ? MaskedInput.conformToMask(valueStr, mask, {
        guide: guide
      }).conformedValue : valueStr;
    });
    _defineProperty(_this, "blurFunction", function (e) {
      _this.setState({
        isFocused: false,
        value: _this.getValueFormatted(_this.state.value) /* [1] */
      });
      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    });
    /**
     * @function onBlur
     * @param {Event} e - the JavaScript event
     *
     * 1. Precision (extra zeros after the decimal separator)
     *    is disabled when leaving the input field.
     */
    _defineProperty(_this, "onBlur", function (e) {
      /* istanbul ignore next */
      if (_this.props.type === FILE_TYPE$1) {
        setTimeout(function () {
          // Workaround for the blur event triggering a re-render before the onClick of the target was captured. See https://github.com/facebook/react/issues/4210 for further details
          _this.blurFunction(e);
        }, 200);
      } else {
        _this.blurFunction(e);
      }
    });
    _defineProperty(_this, "onFocus", function (e) {
      _this.setState({
        isFocused: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    });
    /**
     * @function prepareValue
     * @param {String|Number} value
     *
     * 1. Trims any white space, uses the correct decimal separator.
     * 2. Truncates the fraction to 2 digits before returning the value
     *    (we cannot use toFixed() here because we don't want a
     *    rounded value).
     */
    _defineProperty(_this, "prepareValue", function (value) {
      var type = _this.props.type;
      if (type === MONEY_TYPE) {
        var valueStr = typeof value === 'number' ? value.toString() : value;
        var preparedValue = valueStr.replace(/ /g, '').replace(',', '.'); /* [1] */
        var matches;
        if (preparedValue) {
          if (_this.props.showAllDecimals) {
            matches = preparedValue.match(/^-?\d+(?:\.\d*)?/);
          } else {
            matches = preparedValue.match(/^-?\d+(?:\.\d{0,2})?/); /* [2] */
          }
          preparedValue = matches ? matches[0] : preparedValue;
        }
        return preparedValue;
      }
      return value;
    });
    /**
     * @function onChange
     * @param {Event} e - the JavaScript event
     */
    _defineProperty(_this, "onChange", function (e) {
      var value = e.target.value;
      if (_this.props.regex) {
        value = value.replace(lib(_this.props.regex), '');
      }
      if (_this.props.type === FILE_TYPE$1) {
        _this.setState({
          selectedFile: e.target.files[0],
          selectedFileName: e.target.files[0].name,
          loaded: 0
        });
        _this.props.onChange(e);
      } else if (_this.props.type === MONEY_TYPE) {
        var preparedValue = _this.prepareValue(value);
        // Only update the internal state if the component is uncontrolled
        /* istanbul ignore next */
        typeof _this.props.value === 'undefined' && _this.setState({
          value: preparedValue
        });
        _this.props.onChange(e, parseFloat(preparedValue));
      } /* istanbul ignore next */else if (_this.props.mask && _this.props.guide) {
        // This solves the issue where the cursor
        // jumps to in front of the first character
        // typed into the field.
        // Not the most elegant way to fix it
        // so please feel free to try and solve it
        // another way!
        var input = {
          el: e.target,
          selectionStart: e.target.selectionStart,
          selectionEnd: e.target.selectionEnd
        };
        /* istanbul ignore next */
        setTimeout(function () {
          input.el.setSelectionRange(input.selectionStart, input.selectionEnd);
        }, 0);
        _this.props.onChange(e);
      } else {
        _this.setState({
          value: value
        });
        _this.props.onChange(e);
      }
    });
    _defineProperty(_this, "removeFile", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.props.onFileRemove && _this.props.onFileRemove();
      _this.refValue = '';
      _this.setState({
        selectedFile: null,
        selectedFileName: null
      });
    });
    _defineProperty(_this, "inputFileClickHandler", function (e) {
      e.stopPropagation();
      e.target.value = null;
    });
    _this.state = {
      isFocused: false,
      value: _this.getValueFormatted(_this.props.value),
      selectedFile: null
    };
    /* istanbul ignore next */
    _this.refValue = _this.inputField && _this.props.type === FILE_TYPE$1 ? _this.inputField.value : undefined;
    _this.amountOfDecimals = _this.props.type === MONEY_TYPE ? _this.props.value ? _this.getAmountOfDecimals(_this.props.value, _this.props.showAllDecimals) : MIN_DECIMALS : 0; /* [1] */
    _this.focusTextInput = _this.focusTextInput.bind(_this);
    return _this;
  }
  _inherits(InputTextOnly, _Component);
  return _createClass(InputTextOnly, [{
    key: "focusTextInput",
    value: function focusTextInput() {
      // Explicitly focus the text input using the raw DOM API
      this.textInput.focus();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focusTextInput();
        this.setState({
          isFocused: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        accept = _this$props2.accept,
        append = _this$props2.append,
        autoFocus = _this$props2.autoFocus,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        error = _this$props2.error,
        guide = _this$props2.guide,
        id = _this$props2.id,
        language = _this$props2.language,
        margin = _this$props2.margin,
        mask = _this$props2.mask,
        maxLength = _this$props2.maxLength,
        name = _this$props2.name,
        placeholder = _this$props2.placeholder,
        prepend = _this$props2.prepend,
        removeAccessibilityLabel = _this$props2.removeAccessibilityLabel,
        required = _this$props2.required,
        suffix = _this$props2.suffix,
        type = _this$props2.type;
      var inputmode = this.props.inputmode;
      if (!ALLOWED_INPUTMODES.includes(inputmode)) {
        inputmode = 'text';
      }
      var _this$state = this.state,
        isFocused = _this$state.isFocused,
        value = _this$state.value;
      return /*#__PURE__*/React__default.createElement(InputOnlyWrapper, {
        className: className,
        error: error,
        disabled: disabled,
        isFocused: isFocused,
        append: append,
        prepend: prepend,
        margin: margin,
        type: type
      }, type !== FILE_TYPE$1 && isValidMask(mask) ? /*#__PURE__*/React__default.createElement(MaskedInput__default, {
        id: id,
        name: name,
        disabled: disabled,
        mask: mask,
        guide: guide,
        placeholder: placeholder,
        onChange: function onChange(e) {
          return _this2.onChange(e);
        },
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        value: value,
        required: required,
        type: type,
        inputMode: inputmode,
        autoFocus: autoFocus,
        ref: function ref(input) {
          _this2.textInput = input;
        }
      }) : /*#__PURE__*/React__default.createElement("input", _extends({
        id: id,
        name: name,
        disabled: disabled,
        placeholder: placeholder,
        onChange: function onChange(e) {
          return _this2.onChange(e);
        },
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        value: value,
        required: required,
        type: type,
        onClick: function onClick(e) {
          return type === FILE_TYPE$1 && _this2.inputFileClickHandler(e);
        },
        accept: accept,
        inputMode: inputmode,
        ref: function ref(input) {
          _this2.textInput = input;
        },
        autoFocus: autoFocus,
        maxLength: maxLength
      }, this.props['data-test'] ? {
        'data-test': this.props['data-test']
      } : {})), type !== FILE_TYPE$1 && suffix && /*#__PURE__*/React__default.createElement(Suffix, null, suffix), type === FILE_TYPE$1 && (this.state.selectedFile === null ? /*#__PURE__*/React__default.createElement(InputFilePlaceHolder, null, /*#__PURE__*/React__default.createElement("span", null, InputTextLabel[language].linkText), InputTextLabel[language].defaultText) : /*#__PURE__*/React__default.createElement(InputFileNameDisplay, {
        disabled: disabled
      }, this.state.selectedFileName)), type === FILE_TYPE$1 && this.state.selectedFile !== null && /*#__PURE__*/React__default.createElement(CloseWrapper, null, /*#__PURE__*/React__default.createElement(componentsButton.IconButton, {
        icon: /*#__PURE__*/React__default.createElement(IcnCross, null),
        kind: "tertiaryNoBg",
        size: "sm",
        onClick: function onClick(e) {
          return _this2.removeFile(e);
        },
        accessibilityText: removeAccessibilityLabel
      })));
    }
  }]);
}(React.Component);
InputTextOnly.propTypes = {
  /** Set a name on the input to retrieve it with event.target.name */
  name: PropTypes.string,
  /** Language that should be used for optional text display */
  language: PropTypes.oneOf(availableLanguages),
  /** Whether the input field is disabled */
  disabled: PropTypes.bool,
  /** Error message */
  error: PropTypes.bool,
  /** Array or function that defines how the user input is going to be masked. Refer to the react-text-mask documentation for more details. */
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  /** The maximum number of characters allowed */
  maxLength: PropTypes.number,
  /** For masked inputs: prints out placeholder characters "_" for positions which still need to be filled in. */
  guide: PropTypes.bool,
  /** Show all the decimals passed to an input type='money' (instead of the default 2) */
  showAllDecimals: PropTypes.bool,
  /** Call a custom function onBlur */
  onBlur: PropTypes.func,
  /** Call a custom function onChange. For type 'money', receives the unformatted value as a number as a second parameter (the first being the event). */
  onChange: PropTypes.func.isRequired,
  /** Call a custom function onFocus */
  onFocus: PropTypes.func,
  /** Called when the file is removed (only for type=file) */
  onFileRemove: PropTypes.func,
  /** Placeholder text - should not replace the label !, will be used as default text inside input file type */
  placeholder: PropTypes.string,
  /** Whether the input field is required */
  required: PropTypes.bool,
  /** Text displayed on the right */
  suffix: PropTypes.string,
  /** Accepts all HTML input types, plus 'money'. */
  type: PropTypes.oneOf(['text', 'email', 'number', 'password', 'money', 'file']),
  /** Set the input value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /** 'id' attribute to apply to the input. Only use this in combination with the 'externalLabel' prop to implement your own label. */
  id: PropTypes.string,
  /** Label text */
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /** Visually hide the label while keeping it in the DOM for accessibility */
  hideLabel: PropTypes.bool,
  /** Use when the input is displayed to the left, grouped with another input element.  */
  prepend: PropTypes.bool,
  /** Use when the input is displayed to the right, grouped with another input element.  */
  append: PropTypes.bool,
  /** this will add a margin shortcut css rule */
  margin: PropTypes.string,
  /** set the accepted files: could be "audio/*", "video/*", "image/*" or media type */
  accept: PropTypes.string,
  /** only for file type field, set the remove file label, is used as the icon removal accessibility text also */
  removeAccessibilityLabel: PropTypes.string,
  /** To choose which keyboard should popup on mobile */
  inputmode: PropTypes.oneOf(['none', 'text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url']),
  /** Remove unwanted character with regex */
  regex: PropTypes.string,
  /** set focus to active */
  autoFocus: PropTypes.bool,
  /** Unique attribute used for testing purposes, typically for selecting elements in automated tests */
  'data-test': PropTypes.string
};
InputTextOnly.defaultProps = {
  language: 'en',
  guide: true
};
var colors$3 = functions.config.colors.list;
var InputTextWrapper = styled.div.withConfig({
  displayName: "InputTextstyles__InputTextWrapper",
  componentId: "sc-1lrfch8-0"
})(["margin:", ";", ""], function (props) {
  return props.margin;
}, function (props) {
  return props.validationSpace && !props.isMobile ? 'margin-right: 3rem;' : null;
});
var InputAndIconWrapper = styled.div.withConfig({
  displayName: "InputTextstyles__InputAndIconWrapper",
  componentId: "sc-1lrfch8-1"
})(["position:relative;display:flex;align-items:center;"]);
var ValidationIcon = styled.div.withConfig({
  displayName: "InputTextstyles__ValidationIcon",
  componentId: "sc-1lrfch8-2"
})(["position:absolute;right:-3rem;"]);
var DescriptionWrapper = styled.p.withConfig({
  displayName: "InputTextstyles__DescriptionWrapper",
  componentId: "sc-1lrfch8-3"
})(["margin:", ";color:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.theme.type === 'secure' ? '.2rem 0 0' : '.4rem 0 0';
}, colors$3.GreyDark, function (props) {
  return props.theme.type === 'secure' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.theme.type === 'secure' ? '1.6rem' : '1.8rem';
});
var ErrorWrapper = styled.p.withConfig({
  displayName: "InputTextstyles__ErrorWrapper",
  componentId: "sc-1lrfch8-4"
})(["margin:", ";color:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.theme.type === 'secure' ? '.2rem 0 0' : '.4rem 0 0';
}, colors$3.Tomato, function (props) {
  return props.theme.type === 'secure' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.theme.type === 'secure' ? '1.6rem' : '1.8rem';
});
var InputMainWrapper = styled.div.withConfig({
  displayName: "InputTextstyles__InputMainWrapper",
  componentId: "sc-1lrfch8-5"
})([""]);
var _helpers$resolutions = functions.helpers.resolutions,
  getCurrentResolution = _helpers$resolutions.getCurrentResolution,
  MOBILE = _helpers$resolutions.MOBILE;
var availableLanguages$1 = ['en', 'nl', 'fr', 'de'];
var BaseInputText = /*#__PURE__*/function (_Component) {
  function BaseInputText() {
    var _this;
    _classCallCheck(this, BaseInputText);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BaseInputText, [].concat(args));
    _defineProperty(_this, "state", {
      isMobile: /* istanbul ignore next */
      typeof window !== 'undefined' ? getCurrentResolution() === MOBILE : true
    });
    _defineProperty(_this, "componentDidMount", function () {
      typeof window !== 'undefined' && window.addEventListener('resize', _this.onResizeHandler);
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      typeof window !== 'undefined' && window.removeEventListener('resize', _this.onResizeHandler);
    });
    _defineProperty(_this, "onResizeHandler", function (e) {
      _this.setState({
        isMobile: getCurrentResolution() === MOBILE
      });
    });
    return _this;
  }
  _inherits(BaseInputText, _Component);
  return _createClass(BaseInputText, [{
    key: "render",
    value: function render() {
      var uniqueID = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
      var _this$props = this.props,
        append = _this$props.append,
        autoFocus = _this$props.autoFocus,
        description = _this$props.description,
        disabled = _this$props.disabled,
        error = _this$props.error,
        errorMessage = _this$props.errorMessage,
        externalLabel = _this$props.externalLabel,
        guide = _this$props.guide,
        hideLabel = _this$props.hideLabel,
        hideOptionalLabelText = _this$props.hideOptionalLabelText,
        id = _this$props.id,
        inputmode = _this$props.inputmode,
        isOptional = _this$props.isOptional,
        isValid = _this$props.isValid,
        label = _this$props.label,
        labelWeight = _this$props.labelWeight,
        language = _this$props.language,
        margin = _this$props.margin,
        mask = _this$props.mask,
        maxLength = _this$props.maxLength,
        name = _this$props.name,
        placeholder = _this$props.placeholder,
        prepend = _this$props.prepend,
        regex = _this$props.regex,
        removeAccessibilityLabel = _this$props.removeAccessibilityLabel,
        showAllDecimals = _this$props.showAllDecimals,
        suffix = _this$props.suffix,
        type = _this$props.type,
        validationSpace = _this$props.validationSpace,
        value = _this$props.value;
      var inputAndIconWrapper = /*#__PURE__*/React__default.createElement(InputAndIconWrapper, null, /*#__PURE__*/React__default.createElement(InputTextOnly, _extends({
        append: append,
        autoFocus: autoFocus,
        disabled: disabled,
        error: !!errorMessage || error,
        guide: guide,
        id: id || uniqueID,
        inputmode: inputmode,
        language: language,
        mask: mask,
        name: name,
        onBlur: this.props.onBlur,
        onChange: this.props.onChange,
        onFileRemove: this.props.onFileRemove,
        onFocus: this.props.onFocus,
        maxLength: maxLength,
        placeholder: placeholder,
        prepend: prepend,
        regex: regex,
        removeAccessibilityLabel: removeAccessibilityLabel,
        required: !isOptional,
        showAllDecimals: showAllDecimals,
        suffix: suffix,
        type: type,
        value: value
      }, this.props['data-test'] ? {
        'data-test': this.props['data-test']
      } : {})), validationSpace && isValid && !errorMessage && !this.state.isMobile && /*#__PURE__*/React__default.createElement(ValidationIcon, null, /*#__PURE__*/React__default.createElement(IcnCheckCircle, null)));
      return /*#__PURE__*/React__default.createElement(InputTextWrapper, {
        isMobile: this.state.isMobile,
        validationSpace: validationSpace,
        margin: margin
      }, !externalLabel && (hideLabel ? /*#__PURE__*/React__default.createElement(componentsVisuallyhidden.VisuallyHidden, null, /*#__PURE__*/React__default.createElement(componentsLabel.Label, {
        htmlFor: id || uniqueID,
        weight: labelWeight
      }, label)) : label ? /*#__PURE__*/React__default.createElement(componentsLabel.Label, {
        htmlFor: id || uniqueID,
        weight: labelWeight,
        isOptional: isOptional,
        showOptionalText: !hideOptionalLabelText,
        language: language
      }, label) : null), /*#__PURE__*/React__default.createElement(InputMainWrapper, null, inputAndIconWrapper), description && /*#__PURE__*/React__default.createElement(DescriptionWrapper, null, description), errorMessage && /*#__PURE__*/React__default.createElement(ErrorWrapper, null, errorMessage));
    }
  }]);
}(React.Component);
var commonPropTypes = {
  /** Language that should be used for optional text display */
  language: PropTypes.oneOf(availableLanguages$1),
  /** Set a name on the input to retrieve it with event.target.name */
  name: PropTypes.string,
  /** Text displayed below the input to provide additional information (e.g. password strength requirements). Styles we only be applied if passed as a string. */
  description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /** Whether the input field is disabled */
  disabled: PropTypes.bool,
  /** Display the error styles (if you want an error message as well, use the "errorMessage" prop) */
  error: PropTypes.bool,
  /** Error message text and styles ("error" prop is not needed if you are already passing an errorMessage) */
  errorMessage: PropTypes.string,
  /** Show validation icon. Will *not* show if there is a props.errorMessage or if props.validationSpace is not set to true. */
  isValid: PropTypes.bool,
  /** Array or function that defines how the user input is going to be masked. Refer to the react-text-mask documentation for more details. */
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  /** The maximum number of characters allowed */
  maxLength: PropTypes.number,
  /** For masked inputs: prints out placeholder characters "_" for positions which still need to be filled in. */
  guide: PropTypes.bool,
  /** Show all the decimals passed to an input type='money' (instead of the default 2) */
  showAllDecimals: PropTypes.bool,
  /** Call a custom function onBlur */
  onBlur: PropTypes.func,
  /** Call a custom function onChange */
  onChange: PropTypes.func.isRequired,
  /** Call a custom function onFocus */
  onFocus: PropTypes.func,
  /** Called when the file is removed (only for type=file) */
  onFileRemove: PropTypes.func,
  /** Placeholder text - should not replace the label ! */
  placeholder: PropTypes.string,
  /** Whether the input field is Optional (required by default) */
  isOptional: PropTypes.bool,
  /** Whether to show (Optional) text above Label (false by default). Applicable only if hideLabel is set to false and isOptional set to true.  */
  hideOptionalLabelText: PropTypes.bool,
  /** Text displayed on the right */
  suffix: PropTypes.string,
  /** Accepts all HTML input types, plus 'money'. */
  type: PropTypes.oneOf(['text', 'email', 'number', 'password', 'money', 'file']),
  /** Add spacing allocated to validation icon. This might be needed even if you never show the icon on the input field, to align it with other fields. */
  validationSpace: PropTypes.bool,
  /** Set the input value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /** Use when the input is displayed to the left, grouped with another input element.  */
  prepend: PropTypes.bool,
  /** Use when the input is displayed to the right, grouped with another input element.  */
  append: PropTypes.bool,
  /** only for file type field, set the remove file label, is used as the icon removal accessibility text also */
  removeAccessibilityLabel: PropTypes.string,
  /** To choose which keyboard should popup on mobile */
  inputmode: PropTypes.oneOf(['none', 'text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url']),
  /** To remove unwanted character with a regex */
  regex: PropTypes.string,
  /** activate focus */
  autoFocus: PropTypes.bool,
  /** Unique attribute used for testing purposes, typically for selecting elements in automated tests */
  'data-test': PropTypes.string
};
BaseInputText.propTypes = _objectSpread2({
  /** Don't render a label. Remember a label is required for a11y, only use this prop if you plan to display the label outside of this component using the 'id' prop. Otherwise use the prop 'hideLabel' */
  externalLabel: PropTypes.bool,
  /** 'id' attribute to apply to the input. Only use this in combination with the 'externalLabel' prop to implement your own label. */
  id: PropTypes.string,
  /** Label text */
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /** Visually hide the label while keeping it in the DOM for accessibility */
  hideLabel: PropTypes.bool
}, commonPropTypes);
BaseInputText.defaultProps = {
  type: 'text',
  inputmode: 'text',
  guide: true
};
var InputText = function InputText(props) {
  return /*#__PURE__*/React__default.createElement(BaseInputText, props);
};
InputText.propTypes = _objectSpread2({
  /** Label text */
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  /** Set the font weight of the label */
  labeWeight: PropTypes.oneOf(['regular', 'semiBold']),
  /** Visually hide the label while keeping it in the DOM for accessibility */
  hideLabel: PropTypes.bool
}, commonPropTypes);
InputText.defaultProps = _objectSpread2(_objectSpread2({}, BaseInputText.defaultProps), {}, {
  language: 'en',
  showAllDecimals: false
});
var InputTextExternalLabel = function InputTextExternalLabel(props) {
  return /*#__PURE__*/React__default.createElement(BaseInputText, _extends({
    externalLabel: true,
    id: props.id
  }, props));
};
InputTextExternalLabel.propTypes = _objectSpread2({
  /** 'id' attribute to apply to the input. */
  id: PropTypes.string.isRequired
}, commonPropTypes);
InputTextExternalLabel.defaultProps = BaseInputText.defaultProps;
exports.InputText = InputText;
exports.InputTextExternalLabel = InputTextExternalLabel;
exports.InputTextOnly = InputTextOnly;